export default {
  "linkPadding": "_linkPadding_1njv4_5",
  "link": "_link_1njv4_5",
  "upgrade": "_upgrade_1njv4_22",
  "inherit": "_inherit_1njv4_32",
  "table": "_table_1njv4_42",
  "placeholder": "_placeholder_1njv4_54"
};import "ni:sha-256;cHxzizgHyTJNyA3OttnzUt0dbfjBYEUnonMy39FH3Hw";